import React, { useEffect, useState } from 'react';
import moment from 'moment';

export default function HeaderDate() {
    const [currentTime, setCurrentTime] = useState(null);

    useEffect(() => {
        const timer = setInterval(() => {
            startCurrentTime();
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const startCurrentTime = () => {
        setCurrentTime(moment().format('DD MMM YYYY, HH:mm:ss'));
    };

    return <span className={'p-4'}>{currentTime}</span>;
}
